import DashboardHeader from "../components/headers/DashboardHeader";
import { useNavigate } from "react-router-dom";
import { detail_user_form } from "../DAL/form/userForm";
import { Button, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { s3baseUri } from "../config/config";
import RequiredDocumentsDialog from "../components/dialogs/RequiredDocumentsDialog";
import AddAddonDialog from "../components/dialogs/AddAddonDialog";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AirplaneTicketIcon from "@mui/icons-material/AirplaneTicket";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";

const Dashboard = () => {
  const navigate = useNavigate();

  const [initialLoading, setInitialLoading] = useState(true);
  const [findData, setFindData] = useState(false);
  const [formList, setFormList] = useState({});
  const [showRequiredDocsDialog, setShowRequiredDocsDialog] = useState(false);
  const [showAddOnDialog, setShowAddOnDialog] = useState(false);

  const handleFetchDetail = async () => {
    setInitialLoading(true);
    const result = await detail_user_form();
    if (result.code === 200) {
      const hasCompleted =
        Array.isArray(result?.form?.form) &&
        result.form.form.some((item) => item.is_completed === true);
      setFindData(hasCompleted);
      setFormList(result?.form);
      setInitialLoading(false);
    } else {
      setInitialLoading(false);
    }
  };

  const handleFileAform = () => {
    if (findData) {
      navigate("/draft-page");
    } else {
      // Show the required documents dialog first
      setShowRequiredDocsDialog(true);
    }
  };

  const handleContinueToApplication = () => {
    setShowRequiredDocsDialog(false);
    navigate("/visa/getting_started");
  };

  const handlePaymentClick = () => {
    navigate("/payments");
  };
  const handleTravelDocumentClick = () => {
    navigate("/travel-documents");
  };

  useEffect(() => {
    if (!localStorage.getItem("code-verified")) {
      navigate("/login", { replace: true });
    } else {
      handleFetchDetail();
    }
  }, []);

  if (initialLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "100vh",
        }}
      >
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <div className="layout-container">
      <DashboardHeader />
      <div className="dashboard">
        <div className="welcome-section">
          <h2>Welcome To Your Account</h2>
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <div
                className="card card-dashboard d-flex flex-column h-100 text-start"
                style={{ padding: "24px", borderRadius: "16px" }}
              >
                {findData ? (
                  <>
                    <div className="d-flex align-items-center mb-3">
                      <div
                        style={{
                          backgroundColor: "#e8f5f3",
                          borderRadius: "12px",
                          width: "48px",
                          height: "48px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "16px",
                          flexShrink: 0,
                        }}
                      >
                        <InsertDriveFileIcon
                          sx={{ fontSize: 28, color: "#15978a" }}
                        />
                      </div>
                      <h4 className="mb-0">View Application</h4>
                    </div>
                    <p className="mb-0">
                      Review your form, upload any missing evidence, and track
                      your application online.
                    </p>
                    <div className="mt-auto pt-3">
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={handleFileAform}
                      >
                        View Application
                      </Button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="d-flex align-items-center mb-3">
                      <div
                        style={{
                          backgroundColor: "#e8f5f3",
                          borderRadius: "12px",
                          width: "48px",
                          height: "48px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "16px",
                          flexShrink: 0,
                        }}
                      >
                        <InsertDriveFileIcon
                          sx={{ fontSize: 28, color: "#15978a" }}
                        />
                      </div>
                      <h4 className="mb-0">File Your Application</h4>
                    </div>
                    <p className="mb-0">
                      Start a new application, upload required documents, review
                      disclaimers, review and sign all required legal consents,
                      and submit.
                    </p>
                    <div className="mt-auto pt-3">
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={handleFileAform}
                      >
                        Start Application
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <div
                className="card card-dashboard d-flex flex-column h-100 text-start"
                style={{ padding: "24px", borderRadius: "16px" }}
              >
                <div className="d-flex align-items-center mb-3">
                  <div
                    style={{
                      backgroundColor: "#e8f5f3",
                      borderRadius: "12px",
                      width: "48px",
                      height: "48px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "16px",
                      flexShrink: 0,
                    }}
                  >
                    <AccountBoxIcon sx={{ fontSize: 28, color: "#15978a" }} />
                  </div>
                  <h4 className="mb-0">Edit Profile</h4>
                </div>
                <p className="mb-0">
                  Users can only upload or change their profile photo in this
                  section.
                </p>
                <div className="mt-auto pt-3">
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => {
                      navigate("/edit-profile");
                    }}
                  >
                    Edit Profile
                  </Button>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <div
                className="card card-dashboard d-flex flex-column h-100 text-start"
                style={{ padding: "24px", borderRadius: "16px" }}
              >
                <div className="d-flex align-items-center mb-3">
                  <div
                    style={{
                      backgroundColor: "#e8f5f3",
                      borderRadius: "12px",
                      width: "48px",
                      height: "48px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "16px",
                      flexShrink: 0,
                    }}
                  >
                    <CreditCardIcon sx={{ fontSize: 28, color: "#15978a" }} />
                  </div>
                  <h4 className="mb-0">Payments</h4>
                </div>
                <p className="mb-0">
                  Manage your processing fees and <br />
                  In-country investment payments.
                </p>
                <div className="mt-auto pt-3">
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handlePaymentClick}
                  >
                    Payments
                  </Button>
                </div>
              </div>
            </div>

            {/* Background Screening Document */}
            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <div
                className="card card-dashboard d-flex flex-column h-100 text-start"
                style={{ padding: "24px", borderRadius: "16px" }}
              >
                <div className="d-flex align-items-center mb-3">
                  <div
                    style={{
                      backgroundColor: "#e8f5f3",
                      borderRadius: "12px",
                      width: "48px",
                      height: "48px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "16px",
                      flexShrink: 0,
                    }}
                  >
                    <DescriptionIcon sx={{ fontSize: 28, color: "#15978a" }} />
                  </div>
                  <h4 className="mb-0">Background Screening</h4>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0">
                    View your official background screening results from the
                    authorized third party vendor.
                  </p>
                  <span className="caption-text fst-italic mt-2 d-block">
                    Status will appear once results are ready and uploaded to
                    the user’s account.
                  </span>
                </div>
                <div className="mt-auto pt-3">
                  <Button
                    variant="contained"
                    fullWidth
                    disabled={!(formList?.background_screen_files?.length > 0)}
                    onClick={() => {
                      if (formList?.background_screen_files?.length > 0) {
                        window.open(
                          s3baseUri + formList?.background_screen_files[0]?.path
                        );
                      }
                    }}
                  >
                    View Document
                  </Button>
                </div>
              </div>
            </div>

            {/* Visa File Document */}
            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <div
                className="card card-dashboard d-flex flex-column h-100 text-start"
                style={{ padding: "24px", borderRadius: "16px" }}
              >
                <div className="d-flex align-items-center mb-3">
                  <div
                    style={{
                      backgroundColor: "#e8f5f3",
                      borderRadius: "12px",
                      width: "48px",
                      height: "48px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "16px",
                      flexShrink: 0,
                    }}
                  >
                    <AssignmentIndIcon
                      sx={{ fontSize: 28, color: "#15978a" }}
                    />
                  </div>
                  <h4 className="mb-0">Visa Status</h4>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0">View your approved visa status.</p>
                  <span className="caption-text fst-italic mt-2 d-block">
                    {formList?.external_files?.length > 0
                      ? "View your Visa File document uploaded by LHG team."
                      : "This file is not uploaded by LHG team yet."}
                  </span>
                </div>
                <div className="mt-auto pt-3">
                  <Button
                    variant="contained"
                    fullWidth
                    disabled={!(formList?.external_files?.length > 0)}
                    onClick={() => {
                      if (formList?.external_files?.length > 0) {
                        window.open(
                          s3baseUri + formList?.external_files[0]?.path
                        );
                      }
                    }}
                  >
                    View Document
                  </Button>
                </div>
              </div>
            </div>

            {/* Travel Document */}
            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <div
                className="card card-dashboard d-flex flex-column h-100 text-start"
                style={{
                  padding: "24px",
                  borderRadius: "16px",
                }}
              >
                <div className="d-flex align-items-center mb-3">
                  <div
                    style={{
                      backgroundColor: "#e8f5f3",
                      borderRadius: "12px",
                      width: "48px",
                      height: "48px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "16px",
                      flexShrink: 0,
                    }}
                  >
                    <AirplaneTicketIcon
                      sx={{ fontSize: 28, color: "#15978a" }}
                    />
                  </div>
                  <h4 className="mb-0">Travel Document Information</h4>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0">Upload your airline travel document.</p>
                  {!(
                    formList?.initial_payment_status === "paid" &&
                    formList?.investment_payment_status === "paid"
                  ) && (
                    <span className="caption-text fst-italic mt-2 d-block">
                      You can upload your travel document after paying the
                      Application & Background Fee and In-Country Investment
                      Fee.
                    </span>
                  )}
                </div>
                <div className="mt-auto pt-3">
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleTravelDocumentClick}
                    disabled={
                      !(
                        formList?.initial_payment_status === "paid" &&
                        formList?.investment_payment_status === "paid"
                      )
                    }
                  >
                    Travel Document
                  </Button>
                </div>
              </div>
            </div>

            {/* Add-on - Hidden*/}
            {/* <div className="col-12 col-md-6 col-lg-4 mb-4">
              <div
                className="card card-dashboard d-flex flex-column h-100 text-start"
                style={{ padding: "24px", borderRadius: "16px" }}
              >
                <div className="d-flex align-items-center mb-3">
                  <div
                    style={{
                      backgroundColor: "#e8f5f3",
                      borderRadius: "12px",
                      width: "48px",
                      height: "48px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "16px",
                      flexShrink: 0,
                    }}
                  >
                    <PeopleAltIcon sx={{ fontSize: 28, color: "#15978a" }} />
                  </div>
                  <h4 className="mb-0">Add-on</h4>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0">
                    Limit : {formList?.added_addon_count}/
                    {formList?.allowed_addon_limit}
                  </p>

                  <span className="caption-text fst-italic mt-2 d-block">
                    {formList?.investment_payment_status !== "paid"
                      ? "You canot apply for an Add-on right now. Complete your application first."
                      : "You can apply for an Add-on."}
                  </span>

                  {formList?.added_addon_count >=
                    formList?.allowed_addon_limit && (
                    <span
                      className="caption-text d-block mt-2"
                      style={{ color: "#ef4444" }}
                    >
                      You have reached the maximum limit of add-ons.
                    </span>
                  )}
                </div>
                <div className="mt-auto pt-3">
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => setShowAddOnDialog(true)}
                    disabled={
                      formList?.initial_payment_status !== "paid" ||
                      formList?.investment_payment_status !== "paid" ||
                      formList?.added_addon_count >=
                        formList?.allowed_addon_limit
                    }
                  >
                    Apply for Add-on
                  </Button>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* =========Required-Document-Dialog======= */}
      <RequiredDocumentsDialog
        open={showRequiredDocsDialog}
        onClose={() => setShowRequiredDocsDialog(false)}
        onContinue={handleContinueToApplication}
      />
      {/* ========ADD-ON-DIALOG======== */}
      <AddAddonDialog
        open={showAddOnDialog}
        onClose={() => setShowAddOnDialog(false)}
        handleFetchDetail={handleFetchDetail}
      />
    </div>
  );
};

export default Dashboard;
